export const graphConstants = {
  LOADING_GRAPH__START: 'LOADING_GRAPH__START',
  LOADING_GRAPH__SUCCESS: 'LOADING_GRAPH__SUCCESS',
  LOADING_GRAPH__ERROR: 'LOADING_GRAPH__ERROR',
  LAMBDA_LOADING_GRAPH__SUCCESS: 'LAMBDA_LOADING_GRAPH__SUCCESS',
};
